import React from 'react';
import defaultClasses from './columnGroup.css';
import { mergeClasses } from '@magento/venia-ui/lib/classify';
import { shape, string } from 'prop-types';

/**
 * Page Builder ColumnGroup component.
 *
 * This component is part of the Page Builder / PWA integration. It can be consumed without Page Builder.
 *
 * @typedef ColumnGroup
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that wraps {@link Column} components.
 */
var ColumnGroup = props => {
  var classes = mergeClasses(defaultClasses, props.classes);
  var {
    display,
    children
  } = props;
  var dynamicStyles = {
    display
  };
  return /*#__PURE__*/React.createElement("div", {
    style: dynamicStyles,
    className: classes.root
  }, children);
};

/**
 * Props for {@link ColumnGroup}
 *
 * @typedef props
 *
 * @property {Object} classes An object containing the class names for the ColumnGroup
 * @property {String} classes.root CSS classes for the root container element
 * @property {String} display CSS display property
 */
ColumnGroup.propTypes = {
  classes: shape({
    root: string
  }),
  display: string
};
export default ColumnGroup;